/** check that given object coerces to boolean true */
export const isTruthy = <T>(t: T): t is Exclude<typeof t, undefined | null> => !!t
